'use client';
import { WagmiProvider } from 'wagmi';
import { config, WagmiConfig } from '@/wagmi/config';

export { config as WagmiConfig };

const WagmiWeb3Provider = ({ children }: { children: React.ReactNode }) => {
  return <WagmiProvider config={config}>{children}</WagmiProvider>;
};

export default WagmiWeb3Provider;
